import * as React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

/**
 * Product settings form component
 * Handles product settings using React Hook Form Controller for Switch components
 */
export const ProductSettingsForm = () => {
  const { t } = useTranslation(['products', 'common']);
  const { control } = useFormContext();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('settings')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col space-y-4">
        <Controller
          name="isShippable"
          control={control}
          render={({ field }) => (
            <div className="flex flex-col space-y-1">
              <div className="flex items-center space-x-2">
                <Switch id="isShippable" checked={field.value} onCheckedChange={field.onChange} />
                <Label htmlFor="isShippable">{t('isShippable')}</Label>
              </div>
              <p className="text-muted-foreground text-xs">{t('isShippableHelp')}</p>
            </div>
          )}
        />

        <Controller
          name="isTaxable"
          control={control}
          render={({ field }) => (
            <div className="flex items-center space-x-2">
              <Switch id="isTaxable" checked={field.value} onCheckedChange={field.onChange} />
              <Label htmlFor="isTaxable">{t('isTaxable')}</Label>
            </div>
          )}
        />

        <Controller
          name="active"
          control={control}
          render={({ field }) => (
            <div className="flex items-center space-x-2">
              <Switch id="active" checked={field.value} onCheckedChange={field.onChange} />
              <Label htmlFor="active">{t('enabled')}</Label>
            </div>
          )}
        />

        <Controller
          name="autoSync"
          control={control}
          render={({ field }) => (
            <div className="flex items-center space-x-2">
              <Switch id="autoSync" checked={field.value} onCheckedChange={field.onChange} />
              <Label htmlFor="autoSync">{t('autoSync')}</Label>
            </div>
          )}
        />
      </CardContent>
    </Card>
  );
};
